export default __webpack_public_path__ + "static/media/CommunicationError.5ccc9b94.svg";